module.exports = __webpack_public_path__ + "static/3A841E_0_0-eda4efbf1c159ee3b9c7cf73a84d8683.woff";